import { render, staticRenderFns } from "./BillingData.vue?vue&type=template&id=a6d52518&scoped=true&"
import script from "./BillingData.vue?vue&type=script&lang=js&"
export * from "./BillingData.vue?vue&type=script&lang=js&"
import style0 from "./BillingData.vue?vue&type=style&index=0&id=a6d52518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d52518",
  null
  
)

export default component.exports